import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const COURSE_TYPES_QUERY = gql`
  query courseTypes($filters: CourseTypeFiltersInput) {
    courseTypes(filters: $filters) {
      results {
        ...CourseTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default COURSE_TYPES_QUERY
